// extracted by mini-css-extract-plugin
module.exports = {"paginationTable":"n5hX2hBd","ellipsis":"vTTT6pA9","oddRow":"__1iSAWRvp","evenRow":"CnPzm7_U"};